import { Button } from '~shared/shadcn/ui/button';
import { Card, CardContent } from '~shared/shadcn/ui/card';

interface ExclusionCardProps {
  title: string;
  count: number;
  onManage: () => void;
}

export function ExclusionCard({ title, count, onManage }: ExclusionCardProps) {
  return (
    <Card className='border border-gray-200 shadow-sm'>
      <CardContent className='flex items-center justify-between p-4'>
        <div>
          <h4 className='font-medium'>{title}</h4>
          <p className='text-sm text-muted-foreground'>{count} excluded</p>
        </div>
        <Button variant='outline' size='sm' onClick={onManage}>
          Manage
        </Button>
      </CardContent>
    </Card>
  );
}
